import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { match as x } from "./match.js";
import { getOwnerDocument as E } from "./owner.js";
var f = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(function (e) {
  return "".concat(e, ":not([tabindex='-1'])");
}).join(",");

var p = function (o) {
  return o[o.First = 1] = "First", o[o.Previous = 2] = "Previous", o[o.Next = 4] = "Next", o[o.Last = 8] = "Last", o[o.WrapAround = 16] = "WrapAround", o[o.NoScroll = 32] = "NoScroll", o;
}(p || {}),
    L = function (n) {
  return n[n.Error = 0] = "Error", n[n.Overflow = 1] = "Overflow", n[n.Success = 2] = "Success", n[n.Underflow = 3] = "Underflow", n;
}(L || {}),
    N = function (t) {
  return t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t;
}(N || {});

function T() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  return e == null ? [] : Array.from(e.querySelectorAll(f));
}

var b = function (t) {
  return t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t;
}(b || {});

function S(e) {
  var _x;

  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var t;
  return e === ((t = E(e)) == null ? void 0 : t.body) ? !1 : x(r, (_x = {}, _defineProperty(_x, 0, function _() {
    return e.matches(f);
  }), _defineProperty(_x, 1, function _() {
    var l = e;

    for (; l !== null;) {
      if (l.matches(f)) return !0;
      l = l.parentElement;
    }

    return !1;
  }), _x));
}

function F(e) {
  e == null || e.focus({
    preventScroll: !0
  });
}

var M = ["textarea", "input"].join(",");

function h(e) {
  var r, t;
  return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, M)) != null ? t : !1;
}

function v(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (t) {
    return t;
  };
  return e.slice().sort(function (t, l) {
    var n = r(t),
        i = r(l);
    if (n === null || i === null) return 0;
    var o = n.compareDocumentPosition(i);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}

function H(e, r) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;

  var l = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument,
      n = Array.isArray(e) ? t ? v(e) : e : T(e),
      i = l.activeElement,
      o = function () {
    if (r & 5) return 1;
    if (r & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  }(),
      d = function () {
    if (r & 1) return 0;
    if (r & 2) return Math.max(0, n.indexOf(i)) - 1;
    if (r & 4) return Math.max(0, n.indexOf(i)) + 1;
    if (r & 8) return n.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  }(),
      m = r & 32 ? {
    preventScroll: !0
  } : {},
      c = 0,
      s = n.length,
      u;

  do {
    if (c >= s || c + s <= 0) return 0;
    var a = d + c;
    if (r & 16) a = (a + s) % s;else {
      if (a < 0) return 3;
      if (a >= s) return 1;
    }
    u = n[a], u == null || u.focus(m), c += o;
  } while (u !== l.activeElement);

  return r & 6 && h(u) && u.select(), u.hasAttribute("tabindex") || u.setAttribute("tabindex", "0"), 2;
}

export { p as Focus, L as FocusResult, b as FocusableMode, F as focusElement, H as focusIn, T as getFocusableElements, S as isFocusableElement, v as sortByDomNode };